import { useInfiniteScroll } from "../../hooks";
import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import { Skeleton } from "../Skeleton";
import { Spinner } from "../Spinner";
import { ComboBoxItem } from "./ComboBoxItem";
import { useComboBoxContext } from "./context";

export const ComboBoxContent = () => {
  const { t } = useTranslation();
  const {
    filteredOptions,
    contentClassName,
    maxHeight,
    loading,
    loadingMore,
    onLoad,
  } = useComboBoxContext();

  const { containerRef } = useInfiniteScroll({
    onLoad,
    enabled: !loading && !loadingMore && !!onLoad,
  });

  return (
    <div
      ref={containerRef}
      className={cn("overflow-auto p-1 outline-none", contentClassName)}
      style={{ maxHeight }}
      role="presentation"
    >
      {loading ? (
        <div className="flex flex-col gap-1">
          <Skeleton className="w-full h-[34px]" />
          <Skeleton className="w-full h-[34px]" />
          <Skeleton className="w-full h-[34px]" />
        </div>
      ) : (
        <>
          {filteredOptions.map((option, index) => (
            <ComboBoxItem key={option.id} option={option} index={index} />
          ))}

          {filteredOptions.length === 0 && (
            <div className="p-2 text-neutral-500 text-sm">
              {t("comboBox.noResults")}
            </div>
          )}

          {filteredOptions.length > 0 && onLoad && loadingMore && (
            <div className="flex justify-center p-2">
              <Spinner size="xs" color="primary" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
